import { PlusIcon } from "@xola/icons";
import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { SecondaryButton } from "../../components/Common/SecondaryButton";
import { MessageTemplateList } from "../../components/Customers/Templates/MessageTemplateList";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const MessageTemplateListPage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/customers/messageTemplates");
    };

    const handleClickCreate = () => {
        history.push("/customers/messageTemplates/create");
    };

    return (
        <Page title="Message Templates">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Message Templates</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <SecondaryButton icon={<PlusIcon />} onClick={handleClickCreate}>
                        Create Template
                    </SecondaryButton>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <MessageTemplateList />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
